// extracted by mini-css-extract-plugin
export default {"timer":"timer_timer__foJ+W"};